import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { CUBES_BY_SOURCE_TABLE, queryKeys } from '@/lib/query-keys'
import { services } from '@/services'

/**
 * Sekme başına tek bağlantı (sözleşme §6). `data-changed` olayında
 * `['source', event.source, event.table]` önekiyle başlayan her query invalidate edilir.
 * `system.status:view` ekranı kaynak tablosuna değil sağlık özetine dayandığı için
 * ayrıca `queryKeys.systemSources()` de tazelenir.
 *
 * Uygulama kökünde (bkz. `app/providers.tsx`) yalnızca **bir kez** çağrılır.
 *
 * Faz 6 geçişi: canlı veri artık Cube aboneliğinden gelir (`useCubeLiveQuery`) ve
 * bağlantı durumunu `realtime-store`'a WS transport'u yazar. Bu köprü G6.9 prod
 * doğrulamasına kadar yalnızca yedek invalidation olarak kalır, sonra silinir
 * (bkz. docs/CUBE-MIGRATION-PLAN.md G6.7).
 */
export function useRealtimeBridge(enabled: boolean): void {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!enabled) return

    const disconnect = services.realtime.connect({
      onStatusChange: () => {},
      onEvent: (event) => {
        if (event.source === 'app' && event.table === 'notifications') {
          // Kişiye özel olay: zil ve talep sayıları (bildirim talep olayından doğar).
          void queryClient.invalidateQueries({ queryKey: queryKeys.notifications() })
          void queryClient.invalidateQueries({ queryKey: ['hr', 'requests'] })
          return
        }
        void queryClient.invalidateQueries({
          queryKey: queryKeys.source(event.source, event.table),
        })
        void queryClient.invalidateQueries({ queryKey: queryKeys.systemSources() })
        for (const cubeName of CUBES_BY_SOURCE_TABLE[event.table] ?? []) {
          void queryClient.invalidateQueries({ queryKey: queryKeys.cube(cubeName) })
        }
      },
    })

    return disconnect
  }, [enabled, queryClient])
}
